<template>
<div class="main-wrapper" :class="isShow?'position-fixed': ''">
    <BHeader :title="$t('common.pasdeh')" :back="getBackPath()"/>
    <div style="padding: 0px 16px;width:100%;">
        <BContainer class="input-font">
            <BForm>
              <BFormGroup id="member-id-group" labelFor="member-id-input" :label="$t('login.comId')" >
                  <BFormInput id="member-id-input" v-model="sendData.comId" maxlength="15" :placeholder="isJcc ? $t('login.comJccId') : $t('login.comId')" :state="!comIdState" aria-describedby="input-live-feedback"></BFormInput>
                  <BFormInvalidFeedback id="input-live-feedback" v-text="$t('message.pasdeh_enter_required_verb',{name:$t('login.comId')})"></BFormInvalidFeedback>
              </BFormGroup>
              <BFormGroup id="login-id-group" labelFor="login-id-input" :label="$t('login.userId')" >
                  <BFormInput id="login-id-input" v-model="sendData.loginId" maxlength="9" :placeholder="$t('login.userId')" :state="!usrIdState" aria-describedby="input-live-feedback"></BFormInput>
                  <BFormInvalidFeedback id="input-live-feedback" v-text="$t('message.pasdeh_enter_required_verb',{name:$t('login.userId')})"></BFormInvalidFeedback>
              </BFormGroup>
              <BFormGroup id="email-group" labelFor="email-input" :label="$t('pasdeh.email')">
                  <BFormInput id="email-input" v-model="sendData.usrMlAdr" maxlength="128" :placeholder="isJcc ? 'jcc@example.com' : 'univ@example.com'"  type="text" :state="!(adrState || emailFormatState || emailRfcState)" aria-describedby="input-live-feedback"></BFormInput>
                  <BFormInvalidFeedback id="input-live-feedback">{{ getMailErrorContent() }}</BFormInvalidFeedback>
              </BFormGroup>
              <BButton type="submit" class="form-submit" style="width: 100%;height:40px" @click="isShow = true">{{$t('pasdeh.send')}}</BButton>
            </BForm>
        </BContainer>

        <div class="notices-wrapper">
            <BContainer>
                <BCard no-body img-src="" img-left body-class="card-body"  :style="enFlag ? 'word-break: keep-all':''">
                    <div style="width:15px; height:20px;margin-right: 8px;">
                        <BImg :src="star_src"></BImg>
                    </div>
                    <BCardBody align="start" style="padding-right: 8px">
                        <BCardText>
                        {{$t('pasdeh.notice1')}}
                        </BCardText>
                    </BCardBody>
                </BCard>
                <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                    <div style="width:15px; height:20px;margin-right: 8px">
                        <BImg :src="star_src"></BImg>
                    </div>
                    <BCardBody align="start" style="padding-right: 8px">
                        <BCardText>
                        {{ isJcc ? $t('pasdeh.notice4') : $t('pasdeh.notice2') }}
                        </BCardText>
                    </BCardBody>
                </BCard>
                <BCard no-body img-src="" img-left body-class="card-body" :style="enFlag ? 'word-break: keep-all':''">
                    <div style="width:15px; height:20px;margin-right: 8px">
                        <BImg :src="star_src"></BImg>
                    </div>
                    <BCardBody align="start" style="padding-right: 8px">
                        <BCardText>
                        {{$t('pasdeh.notice3')}}
                        </BCardText>
                    </BCardBody>
                </BCard>
            </BContainer>
        </div>
      </div>
    <BOverlay :show="isShow" z-index=1031 no-wrap fixed opacity=0 >
        <template #overlay>
          <BCard no-body align="center" class="notice-card">
            <div class="imgInlie">
                <BImg :src="warning_src" style="2px;"></BImg>
            </div>
            <div v-dompurify-html="$t('common.adminAskSend')"></div>
            <div class="inner-button-wrapper">
                <div class="button-item-small">
                    <BButton @click="isShow = false">{{$t("common.cancel")}}</BButton>
                </div>
                <div class="button-item">
                    <BButton @click="send();isShow = false">OK</BButton>
                </div>
            </div>
          </BCard>
        </template>
    </BOverlay>
</div>
</template>

<script>
import BHeader from '@/views/header.vue'
import { inject } from '@vue/runtime-core'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { email } from '../../utils/validate_cont.js'

export default {
  name: 'pasdeh',
  components: {
    BHeader
  },
  setup () {
    const star_src = require('@/assets/icon/ps.svg')
      const sendData = ref({comId:'', loginId: '', usrMlAdr:'',loginFlg:'',isI18nJp:'true',comIdShowFlg:'',isJcc:''})
    const isShow = ref(false)
    const service = inject('service')
    const { locale,t } = useI18n({ useScope: 'global' });
    const router = useRouter()
    const comIdState = ref(false)
    const usrIdState = ref(false)
    const adrState = ref(false)
    const enFlag =  locale.value == 'en' ? true : false
    const emailFormatState = ref(false)
    const emailRfcState = ref(false)
    const isJcc = ref(sessionStorage.getItem('isJcc') === 'true');

    function getBackPath() {
      const fromJcc = sessionStorage.getItem('isJcc') === 'true';
      return fromJcc ? '/jcclogin' : '/login';
    }

    function getMailErrorContent() {
      if (adrState.value) {
        return t("message.pasdeh_enter_required_verb",{name:t("pasdeh.email")})
      }
      if (emailFormatState.value) {
        return t("message.email_format_verb",{name:t("pasdeh.email")})
      }
      if (emailRfcState.value) {
        return t("message.email1_rfc")
      }

      return '';
    }

    async function send(){

      let regExp = /^(.+)@(.+)$/;
      if (regExp.test(sendData.value.usrMlAdr)) {
        emailFormatState.value =  false
      } else {
        emailFormatState.value = true
      }

      if (sendData.value.comId.length == 0) {
        comIdState.value = true
      } else {
        comIdState.value = false
      }

      if (sendData.value.loginId.length == 0) {
        usrIdState.value = true
      } else {
        usrIdState.value = false
      }

      if (sendData.value.usrMlAdr.length == 0) {
        adrState.value = true
      } else {
        adrState.value = false
      }

      if (!(comIdState.value || usrIdState.value || adrState.value || emailFormatState.value)) {
        sendData.value.loginFlg = 1
        if(locale.value == 'ja') {
            sendData.value.isI18nJp = 'true'
        } else {
            sendData.value.isI18nJp = 'false'
        }

        const fromJcc = sessionStorage.getItem('isJcc') === 'true';
        sendData.value.isJcc = fromJcc;

        const validateData = { invalidStr: sendData.value.usrMlAdr }
        email(validateData).then(res => {
          if (res.code == 201) {
            emailRfcState.value = true
          } else if (res.code == 200) {
            emailRfcState.value = false
            service.pasdeh.pasdeh.send(sendData.value,t).then(res=>{
              const fromJcc = sessionStorage.getItem('isJcc') === 'true';
              if (fromJcc) {
                router.push({ name: 'Jcclogin' });
              } else {
                router.push({ name: 'login' });
              }
            }).catch(e=>{

            })
          }
        }).catch((error) => {
          emailRfcState.value = true
        })
      }

    }


    return {
      enFlag,
      warning_src:require('@/assets/icon/notice_warning.svg'),
      isShow,
      star_src,
      sendData,
      comIdState,
      usrIdState,
      adrState,
      emailFormatState,
      emailRfcState,
      getBackPath,
      getMailErrorContent,
      send,
      isJcc
    }
  },
}
</script>

<style lang="scss" scoped>
    .b-overlay{
        background: rgba(0, 0, 0, 0.6);
    }
    .main-wrapper{
      width:100%;
      padding-top: 48px;
      :deep(.form-control:focus){
        box-shadow: none;
        border-color:#2394F7;
      }
    .notice-card{
      word-break: keep-all;
          width: 300px;
        background: #FFFFFF;
        border-radius: 4px;
        border: none;
        padding: 16px;
        gap: 16px;
        display: flex;
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: #30353B;
        .inner-button-wrapper{
            margin-bottom: 0px;
            margin-top: 8px;
            display:flex;
            flex-direction: row;
            gap: 8px;
            .button-item{
                flex: 1;
                display: flex;
                .btn{
                    width: max-content;
                    flex: 1;
                    padding: 7px 8px;
                    background: #2394F7;
                    border-radius: 4px;
                    font-weight: 600;
                    font-size: 13px;
                    line-height: 18px;
                    color: #FFFFFF;
                    border: none;
                }
                .btn:hover{
                    box-shadow: none!important;
                }
            }
            .button-item-small{
                flex: 0.5;
                display: flex;
                .btn{
                    width: max-content;
                    flex: 1;
                    padding: 7px 8px;
                    background: #A8B0BB;
                    border-radius: 4px;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    border: none;
                    border-radius: 4px;
                    font-weight: 600;
                    font-size: 13px;
                    line-height: 18px;
                    color: #FFFFFF;
                }
                .btn:hover{
                    box-shadow: none!important;
                }
            }
        }
    }
    }
</style>
